import DataTable from 'react-data-table-component';

import SelectCST from './SelectCST';
import SelectCFOP from './SelectCFOP';
import SelectNCM from './SelectNCM';
import SelectCalculo from './SelectCalculo';
import { useState, useMemo, useEffect } from "react";
import * as XLSX from 'xlsx/xlsx.mjs';
import Grid from '@mui/material/Grid'
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import Switch from '@mui/material/Switch';
import { styled } from '@mui/material/styles';


export default function Tabela({ allData, nomeEmpresa, dadosFiltrados, setDadosFiltrados, 
                            pdfNotas, setRetAtivo, retAtivo, autopecasAtivo, setAutopecasAtivo, autopecasRetAtivo, setAutopecasRetAtivo,
                            construcaoCivilAtivo, setConstrucaoCivilAtivo, construcaoCivilRetAtivo, setConstrucaoCivilRetAtivo}) {


  const columns = [
  {
      name: 'Chave',
    selector: row => row.Chave,
    width: '370px',
    sortable: true,
    reorder: true,
  },
  {
      name: 'Nota Fiscal',
    selector: row => row.Nota_Fiscal,
    width: '110px',
    sortable: true,
    reorder: true,
  },
  {
      name: 'NCM',
    selector: row => row.NCM,
    grow: 1,
    sortable: true,
    reorder: true,
  },
  {
      name: 'Data Emissão',
    selector: row => row.Data,
    width: '120px',
    sortable: true,
    reorder: true,
  },
  {
      name: 'Empresa',
      selector: row => row.Empresa,
      width: '300px',
      sortable: true,
      reorder: true,
  },
  {
      name: 'Produto',
      selector: row => row.Produto,
      width: '350px',
      sortable: true,
      reorder: true,
  },
  {
      name: 'CST',
      selector: row => row.CST,
      width: '80px',
      sortable: true,
      reorder: true,
  },
  {
      name: 'CFOP',
      selector: row => row.CFOP,
      width: '100px',
      sortable: true,
      reorder: true,
  },
  {
      name: 'IPI',
      selector: row => row.IPI,
      width: '60px',
      reorder: true,
  },
  {
      name: 'Valor',
    selector: row => row.Valor_Produto,
    width: '100px',
    right: true,
    reorder: true,
  },
  {
      name: 'Desconto',
    selector: row => row.Desconto,
    width: '100px',
    right: true,
    sortable: true,
    reorder: true,
  },
  {
      name: 'Outro',
    selector: row => row.Outras_Despesas,
    width: '100px',
    right: true,
    sortable: true,
    reorder: true,
  },
  {
      name: 'Frete',
    selector: row => row.Frete,
    width: '80px',
    right: true,
    sortable: true,
    reorder: true,
  },
  {
      name: 'ICMS',
    selector: row => row.ICMS,
    width: '80px',
    right: true,
    reorder: true,
    omit: (retAtivo || autopecasAtivo || autopecasRetAtivo || construcaoCivilAtivo || construcaoCivilRetAtivo)
  },
  {
      name: 'ICMS RET',
    selector: row => row.ICMSRET,
    width: '100px',
    right: true,
    reorder: true,
    omit: !retAtivo
  },
  {
      name: 'ICMS Autopeças',
    selector: row => row.ICMSAUTOPECAS,
    width: '120px',
    right: true,
    reorder: true,
    omit: !autopecasAtivo
  },
  {
      name: 'ICMS Autopeças RET',
    selector: row => row.ICMSAUTOPECASRET,
    width: '150px',
    right: true,
    reorder: true,
    omit: !autopecasRetAtivo
  },
  {
      name: 'ICMS Construção Civil',
    selector: row => row.ICMSCONSTRUCAOCIVIL,
    width: '160px',
    right: true,
    reorder: true,
    omit: !construcaoCivilAtivo
  },
  {
      name: 'ICMS Construção Civil RET',
    selector: row => row.ICMSCONSTRUCAOCIVILRET,
    width: '180px',
    right: true,
    reorder: true,
    omit: !construcaoCivilRetAtivo
  },
  {
      name: 'DANFE',
    selector: row => danfePdf(row.Chave),
    width: '80px',
    center: true,
    reorder: true,
  },
  ];
  
  const danfePdf = (chave) => {
    return <div style={{cursor: "pointer"}} onClick={()=> imprimirPdf(chave)}><PictureAsPdfIcon /></div>
  }

  const imprimirPdf = async (chave) => {
    let corpo = pdfNotas[chave]
    let base = await fetch('https://ws.meudanfe.com/api/v1/get/nfe/xmltodanfepdf/API', {
         method: "POST",
         body: corpo
    });
    if (200 !== base.status) {
      alert("Falha ao gerar PDF! Por favor, tente mais tarde.")
    }
    let pdf = await base.json();
    try {
      let novaAba = window.open("about:blank");
      novaAba.document.write("<html<head><title>" + chave + ".pdf</title><style>body{margin: 0px;}iframe{border-width: 0px;}</style></head>")
      novaAba.document.write("<body><embed width='100%' height='100%' src='data:application/pdf;base64," + pdf + "'></embed></body></html>")
  } catch (l) {
      alert("Para a exibiçãoo do PDF, favor permitir janela pop-up no navegador. Após permitir favor tentar novamente.")
  }
  }

  const temCST = (item) => {
    if (selectedCST.length > 0) {
      for (var ind = 0; ind < selectedCST.length; ind++){
        if (item.CST === selectedCST[ind]) {
          return true
        }
      }
      return false
    } else {
      return true
    }
  }

  const temCFOP = (item) => {
    if (selectedCFOP.length > 0) {
      for (var ind = 0; ind < selectedCFOP.length; ind++){
        if (item.CFOP === selectedCFOP[ind]) {
          return true
        }
      }
      return false
    } else {
      return true
    }
  }

  const temNCM = (item) => {
    if (selectedNCM.length > 0) {
      for (var ind = 0; ind < selectedNCM.length; ind++){
        if (item.NCM === selectedNCM[ind]) {
          return true
        }
      }
      return false
    } else {
      return true
    }
  }

  const temNota = (item) => {
    if (item.Nota_Fiscal.includes(selectedNota)) {
      return true
    } else {
      return false
    }
  }

  const somarICMS = (item) => {
    var temp = 0;
    item.map((nota) => temp = temp + parseFloat(nota.ICMS))
    return temp
  }
  const somarICMSRET = (item) => {
    var temp = 0;
    item.map((nota) => temp = temp + parseFloat(nota.ICMSRET))
    return temp
  }
  const somarICMSAutopecas = (item) => {
    var temp = 0;
    item.map((nota) => temp = temp + parseFloat(nota.ICMSAUTOPECAS))
    return temp
  }
  const somarICMSAutopecasRet = (item) => {
    var temp = 0;
    item.map((nota) => temp = temp + parseFloat(nota.ICMSAUTOPECASRET))
    return temp
  }
  const somarICMSConstrucaoCivil = (item) => {
    var temp = 0;
    item.map((nota) => temp = temp + parseFloat(nota.ICMSCONSTRUCAOCIVIL))
    return temp
  }
  const somarICMSConstrucaoCivilRet = (item) => {
    var temp = 0;
    item.map((nota) => temp = temp + parseFloat(nota.ICMSCONSTRUCAOCIVILRET))
    return temp
  }
  const rowsPerPageText = { rowsPerPageText: 'Linhas por Página:' }
  const [selectedCST, setSelectedCST] = useState([]);
  const [selectedCFOP, setSelectedCFOP] = useState([]);
  const [selectedNCM, setSelectedNCM] = useState([]);
  const [selectedNota, setSelectedNota] = useState("");
  const [selectedCalculo, setSelectedCalculo] = useState("Supermercado");
  const [sumICMS, setSumICMS] = useState(somarICMS(allData));
  const [sumICMSRET, setSumICMSRET] = useState(somarICMSRET(allData));
  const [sumICMSAutopecas, setSumICMSAutopecas] = useState(somarICMSAutopecas(allData));
  const [sumICMSAutopecasRet, setSumICMSAutopecasRet] = useState(somarICMSAutopecasRet(allData));
  const [sumICMSConstrucaoCivil, setSumICMSConstrucaoCivil] = useState(somarICMSConstrucaoCivil(allData));
  const [sumICMSConstrucaoCivilRet, setSumICMSConstrucaoCivilRet] = useState(somarICMSConstrucaoCivilRet(allData));

  useEffect(() => {
    switch(selectedCalculo){
      case "Autopeças":
        setRetAtivo(false);
        setAutopecasAtivo(true);
        setAutopecasRetAtivo(false);
        setConstrucaoCivilAtivo(false);
        setConstrucaoCivilRetAtivo(false);
        break;
      case "Autopeças RET":
        setRetAtivo(false);
        setAutopecasAtivo(false);
        setAutopecasRetAtivo(true);
        setConstrucaoCivilAtivo(false);
        setConstrucaoCivilRetAtivo(false);
        break;
      case "Construção Civil":
        setRetAtivo(false);
        setAutopecasAtivo(false);
        setAutopecasRetAtivo(false);
        setConstrucaoCivilAtivo(true);
        setConstrucaoCivilRetAtivo(false);
        break;
      case "Construção Civil RET":
        setRetAtivo(false);
        setAutopecasAtivo(false);
        setAutopecasRetAtivo(false);
        setConstrucaoCivilAtivo(false);
        setConstrucaoCivilRetAtivo(true);
        break;
      case "Supermercado":
        setRetAtivo(false);
        setAutopecasAtivo(false);
        setAutopecasRetAtivo(false);
        setConstrucaoCivilAtivo(false);
        setConstrucaoCivilRetAtivo(false);
        break;
      case "Supermercado RET":
        setRetAtivo(true);
        setAutopecasAtivo(false);
        setAutopecasRetAtivo(false);
        setConstrucaoCivilAtivo(false);
        setConstrucaoCivilRetAtivo(false);
        break;
      default:
        break;
    }
  }, [selectedCalculo]);

  function handleFilter () {
    const temp = allData.filter(
      item => (temCFOP(item) && temCST(item) && temNCM(item) && temNota(item))
    ) 
    setDadosFiltrados(temp)
    setSumICMS(somarICMS(temp))
    setSumICMSRET(somarICMSRET(temp))
    setSumICMSAutopecas(somarICMSAutopecas(temp))
    setSumICMSAutopecasRet(somarICMSAutopecasRet(temp))
    setSumICMSConstrucaoCivil(somarICMSConstrucaoCivil(temp))
    setSumICMSConstrucaoCivilRet(somarICMSConstrucaoCivilRet(temp))
  }

  const prepararDownload = (dados) => {
    switch(true){
      case retAtivo:
        XLSX.utils.sheet_add_aoa(dados, [["Chave", "Nota Fiscal" , "NCM", "Data",
        "Empresa", "Produto", "CST", "CFOP", "IPI", "Valor do Produto",
        "Desconto", "Outras Despesas", "Frete", "ICMS RET", "", "", "", "", ""]], { origin: "A1" });
        break;
      case autopecasAtivo:
        XLSX.utils.sheet_add_aoa(dados, [["Chave", "Nota Fiscal" , "NCM", "Data",
        "Empresa", "Produto", "CST", "CFOP", "IPI", "Valor do Produto",
        "Desconto", "Outras Despesas", "Frete", "ICMS Autopeças", "", "", "", "", ""]], { origin: "A1" });
        break;
      case autopecasRetAtivo:
        XLSX.utils.sheet_add_aoa(dados, [["Chave", "Nota Fiscal" , "NCM", "Data",
        "Empresa", "Produto", "CST", "CFOP", "IPI", "Valor do Produto",
        "Desconto", "Outras Despesas", "Frete", "ICMS Autopeças RET", "", "", "", "", ""]], { origin: "A1" });
        break;
      case construcaoCivilAtivo:
        XLSX.utils.sheet_add_aoa(dados, [["Chave", "Nota Fiscal" , "NCM", "Data",
        "Empresa", "Produto", "CST", "CFOP", "IPI", "Valor do Produto",
        "Desconto", "Outras Despesas", "Frete", "ICMS Construção Civil", "", "", "", "", ""]], { origin: "A1" });
        break;
      case construcaoCivilRetAtivo:
        XLSX.utils.sheet_add_aoa(dados, [["Chave", "Nota Fiscal" , "NCM", "Data",
        "Empresa", "Produto", "CST", "CFOP", "IPI", "Valor do Produto",
        "Desconto", "Outras Despesas", "Frete", "ICMS Construção Civil RET", "", "", "", "", ""]], { origin: "A1" });
        break;
      default:
        XLSX.utils.sheet_add_aoa(dados, [["Chave", "Nota Fiscal" , "NCM", "Data",
        "Empresa", "Produto", "CST", "CFOP", "IPI", "Valor do Produto",
        "Desconto", "Outras Despesas", "Frete", "ICMS", "", "", "", "", ""]], { origin: "A1" });
        break;
    }

    for(var ind = 2; ind <= dadosFiltrados.length + 1; ind ++){
      const valorIPI = dados["I" + ind].v === " " ? " " : parseFloat(dados["I" + ind].v)
      XLSX.utils.sheet_add_aoa(dados, [[valorIPI]], { origin: "I" + ind });
      dados["I" + ind].z = '#,##0.00_);\\(#,##0.00\\)'
      
      const valorProduto = dados["J" + ind].v === " " ? " " : parseFloat(dados["J" + ind].v)
      XLSX.utils.sheet_add_aoa(dados, [[valorProduto]], { origin: "J" + ind });
      dados["J" + ind].z = '#,##0.00_);\\(#,##0.00\\)'

      const valorDesconto = dados["K" + ind].v === " " ? " " : parseFloat(dados["K" + ind].v)
      XLSX.utils.sheet_add_aoa(dados, [[valorDesconto]], { origin: "K" + ind });
      dados["K" + ind].z = '#,##0.00_);\\(#,##0.00\\)'

      const valorOutrasDespesas = dados["L" + ind].v === " " ? " " : parseFloat(dados["L" + ind].v)
      XLSX.utils.sheet_add_aoa(dados, [[valorOutrasDespesas]], { origin: "L" + ind });
      dados["L" + ind].z = '#,##0.00_);\\(#,##0.00\\)'

      const valorFrete = dados["M" + ind].v === " " ? " " : parseFloat(dados["M" + ind].v)
      XLSX.utils.sheet_add_aoa(dados, [[valorFrete]], { origin: "M" + ind });
      dados["M" + ind].z = '#,##0.00_);\\(#,##0.00\\)'

    switch(true){
      case retAtivo:
        const valorICMSRET = dados["O" + ind].v === " " ? " " : parseFloat(dados["O" + ind].v)
        XLSX.utils.sheet_add_aoa(dados, [[valorICMSRET]], { origin: "N" + ind });
        dados["N" + ind].z = '#,##0.00_);\\(#,##0.00\\)'
        XLSX.utils.sheet_add_aoa(dados, [["", "", "", "", ""]], { origin: "O" + ind });
        break;
      case autopecasAtivo:
        const valorICMSAutopecas = dados["N" + ind].v === " " ? " " : parseFloat(dados["P" + ind].v)
        XLSX.utils.sheet_add_aoa(dados, [[valorICMSAutopecas]], { origin: "N" + ind });
        dados["N" + ind].z = '#,##0.00_);\\(#,##0.00\\)'
        XLSX.utils.sheet_add_aoa(dados, [["", "", "", "", ""]], { origin: "O" + ind });
        break;
      case autopecasRetAtivo:
        const valorICMSAutopecasRet = dados["N" + ind].v === " " ? " " : parseFloat(dados["Q" + ind].v)
        XLSX.utils.sheet_add_aoa(dados, [[valorICMSAutopecasRet]], { origin: "N" + ind });
        dados["N" + ind].z = '#,##0.00_);\\(#,##0.00\\)'
        XLSX.utils.sheet_add_aoa(dados, [["", "", "", "", ""]], { origin: "O" + ind });
        break;
      case construcaoCivilAtivo:
        const valorICMSConstrucaoCivil = dados["N" + ind].v === " " ? " " : parseFloat(dados["R" + ind].v)
        XLSX.utils.sheet_add_aoa(dados, [[valorICMSConstrucaoCivil]], { origin: "N" + ind });
        dados["N" + ind].z = '#,##0.00_);\\(#,##0.00\\)'
        XLSX.utils.sheet_add_aoa(dados, [["", "", "", "", ""]], { origin: "O" + ind });
        break;
      case construcaoCivilRetAtivo:
        const valorICMSConstrucaoCivilRet = dados["N" + ind].v === " " ? " " : parseFloat(dados["S" + ind].v)
        XLSX.utils.sheet_add_aoa(dados, [[valorICMSConstrucaoCivilRet]], { origin: "N" + ind });
        dados["N" + ind].z = '#,##0.00_);\\(#,##0.00\\)'
        XLSX.utils.sheet_add_aoa(dados, [["", "", "", "", ""]], { origin: "O" + ind });
        break;
      default:
        const valorICMS = dados["N" + ind].v === " " ? " " : parseFloat(dados["N" + ind].v)
        XLSX.utils.sheet_add_aoa(dados, [[valorICMS]], { origin: "N" + ind });
        dados["N" + ind].z = '#,##0.00_);\\(#,##0.00\\)'
        XLSX.utils.sheet_add_aoa(dados, [["", "", "", "", ""]], { origin: "O" + ind });
        break;
    }
    }
  }

  const handleDownload = () => {
    var wb = XLSX.utils.book_new(),
      ws = XLSX.utils.json_to_sheet(dadosFiltrados);
    
      ws['!autofilter']={ref:"A1:N1"};
    XLSX.utils.book_append_sheet(wb, ws, "ICMS");


    prepararDownload(ws)
    XLSX.writeFile(wb, `ICMS - ${nomeEmpresa}.xlsx`);
    
  }

  const actionsMemo = useMemo(() => <button className='downloadButton' onClick={handleDownload}><span>Exportar Excel</span></button>, 
  [dadosFiltrados, retAtivo, autopecasAtivo, autopecasRetAtivo,
    construcaoCivilAtivo, construcaoCivilRetAtivo]);
  
  return (
    <div className='paginaTabela'>
      <Box sx={{ flexGrow: 1 }}>
      <Grid container spacing={2}>
          <Grid item xs={9}>
            <div className='filtros'>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <div className="titulo">
                    Filtros da Tabela
                  </div>
                </Grid>
              </Grid>
              <Grid container spacing={2}>
                <Grid item xs={6}>
                    <SelectNCM allData={allData} setSelectedNCM={setSelectedNCM} />
                  </Grid>
                  <Grid item xs={6}>
                  <div style={{marginTop: '10px', marginBottom: '10px'}}><TextField id="notaFiscal" label="Nota Fiscal" onChange={(e)=> setSelectedNota(e.target.value)}  fullWidth  variant="outlined" /></div>
                </Grid>
              </Grid>
              <Grid container spacing={2}>
                <Grid item xs={6}>
                    <SelectCST allData={allData} setSelectedCST={setSelectedCST} />
                  </Grid>
                  <Grid item xs={6}>
                    <SelectCFOP allData={allData} setSelectedCFOP={ setSelectedCFOP} />
                </Grid>
              </Grid>
              <Grid container spacing={2}>
                <Grid item xs={6}>
                  <SelectCalculo selectedCalculo={selectedCalculo} setSelectedCalculo={setSelectedCalculo} />
                  </Grid>
                  <Grid item xs={6}>
                    <div className="alinharDireita">
                    <button className='downloadButton' onClick={handleFilter}>Atualizar Tabela</button>
                    </div>
                  </Grid>
              </Grid>
            </div>
        </Grid>
          <Grid item xs={3}>
            <div className="somaAliquota">
              <div className="dadosSomatorio">
              <h2>Somatório ICMS</h2>
              <h2>
                {construcaoCivilRetAtivo ?
                Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(sumICMSConstrucaoCivilRet.toFixed(2)) :
                (autopecasRetAtivo ? 
                Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(sumICMSAutopecasRet.toFixed(2)) :
                (construcaoCivilAtivo ?
                Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(sumICMSConstrucaoCivil.toFixed(2)) : 
                (retAtivo ?
                Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(sumICMSRET.toFixed(2)) : 
                (autopecasAtivo ?
                  Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(sumICMSAutopecas.toFixed(2)) : 
                  Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(sumICMS.toFixed(2))) )))
                }
                </h2>

              </div>
            </div>
          </Grid>
        </Grid>
        <Grid item xs={12}>
          <div className="tabela">
          <DataTable
        title={`Cálculo ICMS - ${nomeEmpresa}`}
          columns={columns}
        data={dadosFiltrados}
        dense
        pagination
        highlightOnHover
        striped
        actions={actionsMemo}
        paginationRowsPerPageOptions={[10, 25, 50, 200, 500]}
          paginationComponentOptions={rowsPerPageText}
      />
        </div>
          </Grid>
    </Box>
      
      </div>
      );
}